import { TYPED_SIGNATURE_MAX_LENGTH } from "~/shared/documents/schemas/typed-signature.schema";
import { TextInput } from "~/ui";

type Props = {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  description?: string;
};

/** Issuance signature; required for U.S. border documents, org-controlled for other families. */
export const DocumentTypedSignatureModalField = ({ value, onChange, error, required, description }: Props) => (
  <TextInput
    label="Signature"
    description={description ?? "Prints in a signature-style font on the PDF."}
    required={required}
    autoComplete="off"
    value={value}
    maxLength={TYPED_SIGNATURE_MAX_LENGTH}
    onChange={event => onChange(event.currentTarget.value)}
    error={error}
  />
);
